// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "css/vendors.97cffb74.css";
	// return url for filenames based on template
	return "css/" + chunkId + "." + "d10deadd" + ".chunk.css";
};